module.exports = __webpack_public_path__ + "static/img/top_message.5b73cba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/top_message.png
// module id = g5vI
// module chunks = 0